import { render } from "./SearchItemOld.vue?vue&type=template&id=2efa998e"
import script from "./SearchItemOld.vue?vue&type=script&lang=js"
export * from "./SearchItemOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__